import React from 'react';
import { Box, Alert } from '@mui/material';
import InspectionCard from './InspectionCard';
import { ListViewProps } from './types';

/**
 * ListView - Component for displaying inspections in a list format
 */
const ListView: React.FC<ListViewProps> = ({ 
  filteredInspections, 
  handleOpenCompletionDialog, 
  handleViewDetails, 
  handleActionMenuOpen,
  selectedInspection,
  setSelectedInspection,
  handleUpdateStatus,
  handleStartInspection
}) => {
  return (
    <Box>
      {filteredInspections.length === 0 && (
        <Alert severity="info" sx={{ mt: 2 }}>
          No inspections match your current filters.
        </Alert>
      )}

      {filteredInspections.map(inspection => (
        <InspectionCard
          key={inspection.id}
          inspection={inspection}
          handleOpenCompletionDialog={handleOpenCompletionDialog}
          handleViewDetails={handleViewDetails}
          handleActionMenuOpen={handleActionMenuOpen}
          selectedInspection={selectedInspection}
          setSelectedInspection={setSelectedInspection}
          handleUpdateStatus={handleUpdateStatus}
          handleStartInspection={handleStartInspection}
        />
      ))}
    </Box>
  );
};

export default ListView;